<template>
  <el-container>
    <el-main>
      <el-form ref="searchData" :model="searchData" label-width="80px" label-position="top" >
        <el-row :gutter="0" justify="center">
          <el-col :span="4" class="cls-col" v-if="orgType == 1">
            <el-form-item label="机构" prop="orgCode">
              <el-select  placeholder="" size="small" placeholder="机构" v-model="searchData.orgCode" clearable style="width: 100%" @change="changeOrgCode">
                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="范围" prop="scopeName">
              <el-select v-model="searchData.scopeName" size="small" clearable style="width: 100%">
                <el-option v-for="scope in scopeListData"  :value="scope"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="课程名" prop="courseName">
              <el-input v-model="searchData.courseName" placeholder="课程名" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="cls-col">
            <el-form-item label="有效日期" prop="phone" >
              <el-date-picker
                  v-model="searchData.searchTimeStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  size="small"
              >
              </el-date-picker>
              -
              <el-date-picker
                  arrow-control
                  v-model="searchData.searchTimeEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button
                type="primary"
                round
                size="small"
                icon="el-icon-search"
                @click="search()"
            >查询
            </el-button>
            <el-button
                type="success"
                icon="el-icon-circle-plus-outline"
                size="small"
                round
                @click="add"
                class="but-cls"
            >添加
            </el-button>
            <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                round
                @click="deleteMore"
                class="but-cls"
            >删除
            </el-button>
          </el-form-item>
        </el-row>
  
      </el-form>
      <el-table
          :data="welfareData"
          ref="welfares"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%"
          class="tableBox"
          :row-style="{'height':'120'}"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50" ></el-table-column>
        <el-table-column prop="organizationName" label="机构" width="200" ></el-table-column>
        <el-table-column prop="scopeList" :formatter="f_scopeList" label="范围" width="200" ></el-table-column>
        <el-table-column prop="courseList" :formatter="f_courseList" label="福利课程" width="200" ></el-table-column>
        <el-table-column prop="pictureUrl" label="宣传图片"  >
          <template slot-scope="scope">
            <img width="480" height="110" :src="scope.row.pictureUrl"  >
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="开始时间" :formatter="f_dateTime" width="150" ></el-table-column>
        <el-table-column prop="endTime" label="结束时间" :formatter="f_dateTime" width="150" ></el-table-column>
        <el-table-column prop="realName" label="数据统计" width="100">
          <template slot-scope="scope">
            <el-button  @click="detail(scope.row)" type="text" >查看详情</el-button>
          </template>
        </el-table-column>
        
        <el-table-column
            fixed="right"
            label="操作"
            width="160"
        >
          <template slot-scope="scope">
            <el-button  @click="share(scope.row.shareUrl)" type="text" >分享课程</el-button>
            <el-button type="text" @click="edit(scope.row)" >编辑课程</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px"
      ></el-pagination>
    </el-main>
    <el-dialog
        title="数据统计"
        width="30%"
        :visible.sync="showReceive"
        :close-on-click-modal=false
        :before-close="handleClose"
    >
      <el-table
          :data="receiveData"
          border
          style="width: 100%;margin-bottom: 10px"
      >
        <el-table-column type="index" label="序号" width="50" ></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150" ></el-table-column>
        <el-table-column prop="receiveTime" label="课程领取时间" :formatter="f_dateTime"  ></el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="receiveTotal"
          :page-size="receivePageSize"
          :current-page.sync="receiveCurrentPage"
          @current-change="handleReceiveCurrentChange"
          align="right"
      ></el-pagination>
    </el-dialog>
    <el-dialog
        title=""
        width="30%"
        :visible.sync="shareReceive"
        :close-on-click-modal=false
        :before-close="handleShareReceiveClose">
      <el-input v-model="qrCodeUrl" style="width: 70%; margin-right: 10px" readonly ></el-input>
      <el-button class = "copy-code-button"
                 type="primary"
                 round
                 @click="copy"
                 :data-clipboard-text="qrCodeUrl"
      >复制链接</el-button>
      <vue-qr ref="Qrcode"
              :text="qrCodeUrl"
              :callback="test" qid="testQrId"></vue-qr><span>截图分享给朋友</span>
    </el-dialog>
  </el-container>
</template>

<script>
  import {dateFormat,monthFormat} from '@/api/utils.js'
  import VueQr from 'vue-qr'
  import Clipboard from 'clipboard'
  export default {
    name: 'welfare',
    components: {VueQr},
    data() {
      return {
        qrCodeUrl:"",
        welfareData: [],
        receiveData: [],
        scopeListData: [],
        selectData: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        receiveTotal: 0,
        receivePageSize: 10,
        receiveCurrentPage: 1,
        searchData: {
          scopeName: '',
          courseName: '',
          searchTimeStart: '',
          searchTimeEnd: '',
          page: 1,
          size: 0,
        },
        showReceive: false,
        shareReceive: false,
        currentReceive: {},
        org: [],
      };
    },
    methods: {
      changeOrgCode() {
        this.scopeListData = [];
        this.searchData.scopeName = "";
        if(this.searchData.orgCode) {
          this.selectScope();
        }
      },
      copy() {
        var clipboard = new Clipboard('.copy-code-button');
        clipboard.on('success', e => {
          this.$message({
            type: 'success',
            message: '复制成功'
          });
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          this.$message({
            type: 'info',
            message: '设备不支持复制'
          });
          clipboard.destroy()
        })
      },
      test(dataUrl, id) {
        console.log(dataUrl)
        console.log(id)
      },
      handleClose() {
        this.showReceive = false;
      },
      share(shareUrl) {
        this.qrCodeUrl = shareUrl;
        this.shareReceive = true;
      },
      handleShareReceiveClose() {
        this.shareReceive = false;
      },
      detail(row, currentPage) {
        this.currentReceive = row;
        let params = {
          mallWelfareId: row.mallWelfareId,
          size: 10,
          page: 1
        }

        if (currentPage) {
          params.page = currentPage;
        } else {
          this.receiveCurrentPage = 1;
        }
        this.https.fetchPost('/mallWelfare/getReceiveList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.receiveData = data.data.data;
            this.receiveTotal = data.data.total;
            this.showReceive = true;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          this.$message.error('网络错误');
        });
      },
      f_courseList(row, column, cellValue, index) {
        let value = "";
        /*if(cellValue.length > 3) {
          for(let i=0; i<3; i++) {
            value+= cellValue[i]+"\n";
          }
          value = value.substr(0,value.length-1);
          value = <span>{value} <el-button   type="text" style="padding:0" onClick={() => this.showAll()} >更多...</el-button></span>
        } else {
          for(let v of cellValue) {
            value+= v+"\n";
          }
        }*/
        for(let v of cellValue) {
          value+= v+"\n";
        }
        return value;
      },
      f_scopeList(row, column, cellValue, index) {
        let value = "";
        for(let v of cellValue) {
          value+= v+"\n";
        }
        return value;
        // if(cellValue.length > 3) {
        //   for(let i=0; i<3; i++) {
        //     value+= cellValue[i]+"\n";
        //   }
        //   value = value.substr(0,value.length-1);
        //   value = <span>{value} <el-button   type="text" style="padding:0" onClick={() => this.showAll(row, column, cellValue, index)} >更多...</el-button></span>
        // } else {
        //   for(let v of cellValue) {
        //     value+= v+"\n";
        //   }
        // }
        
        // return value;
      },
      f_dateTime(row, column, cellValue, index) {
        if(cellValue != null) {
          let time = dateFormat(cellValue);
          return time.substr(0,time.length-3);
        } else {
          return cellValue
        }
      },
      showAll(row, column, cellValue, index) {
        // row.status = 0;
        let welfares = this.$refs.welfares.columns[index];
        console.log(welfares.style.height);
      },
      handleSelectionChange(val) {
        this.selectData = val;
      },
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      handleReceiveCurrentChange(val) {
        this.detail(this.currentReceive,val);
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = this.pageSize;
        let params = this.searchData;
        this.https.fetchPost('/mallWelfare/getWelfareList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.welfareData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          this.$message.error('网络错误');
        });
      },
      selectScope() {
        let params = {
          scopeType: 0,
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/mallWelfare/getScopeList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.scopeListData = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          this.$message.error('网络错误');
        });
      },
      deleteMore() {
        let roleLength = this.selectData.length;
        this.$confirm('确定要删除'+ roleLength +'条记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = [];
          for(let selected of this.selectData) {
            ids.push(selected.mallWelfareId)
          }
          let params = {
            mallWelfareIdList: ids
          };
          this.https.fetchPost('/mallWelfare/delWelfare', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除成功:' + msg
              });
            }
          }).catch((err) => {
            this.$message.error('网络异常！');
          });
        }).catch(() => {

        });
      },
      add() {
        this.$router.push({
          name: "addWelfare"
        })
      },
      edit(row) {
        this.$router.push({
          name: "addWelfare",
          query: {welfareId: row.mallWelfareId},
        })
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
    },
    created: function() {
      this.search();
      this.orgType = this.$store.state.orgType;
      if(this.orgType != 1) {
        this.searchData.orgCode = this.$store.state.orgCode;
        this.selectScope();
      }
      this.selectOrg();
    }
  };
</script>

<style lang="scss">
  .el-table .cell {
    white-space: pre-line;
  }
</style>